module.exports = __webpack_public_path__ + "b3e5d847a1884499ff6f0dee04d4cb95.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/pirate-hideaway-empty.png
// module id = 2852
// module chunks = 0